import { render, staticRenderFns } from "./CompetencesPanel.vue?vue&type=template&id=30a4e0af&"
import script from "./CompetencesPanel.vue?vue&type=script&lang=js&"
export * from "./CompetencesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports